import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

import DateInput from './DateInput'
import FunctionUtils from '../../../../lambda/FunctionUtils'

export default class DateView extends React.Component {

  static propTypes = {
    jobInfo: PropTypes.shape(),
    dateStr: PropTypes.string.isRequired,
    teamId: PropTypes.string.isRequired
  }

  getModuleInfo = () => {
    return this.props.jobInfo.modules.date
  }

  getRecurrence = () => {
    return this.getModuleInfo().recurrence
  }

  shouldDisableDate = (day) => {
    const diff = moment(day).diff(moment(this.getModuleInfo().startDate), 'days')
    return diff < 0 || diff > 90
  }

  getDate = () => {
    let dateStr = this.getModuleInfo().startDate
    if (!this.props.jobInfo.temporal && this.getRecurrence()) {
      dateStr = this.props.dateStr
    }
    return moment(dateStr).toDate()
  }

  handleStartDateChanged = (n, date) => {
    const startDate = moment(this.getModuleInfo().startDate)
    const endDate = moment(this.getModuleInfo().endDate)
    const diffDays = endDate.diff(startDate, 'days')
    const newStartDate = moment(date)
    this.lastStartDateSelected = newStartDate.format('YYYY-MM-DD')
    const newEndDate = moment(newStartDate).add(diffDays, 'days')
    this.lastEndDateSelected = newEndDate.format('YYYY-MM-DD')
    FunctionUtils.changeDateModuleWithDates(
      this.props.teamId,
      this.props.jobInfo,
      this.lastStartDateSelected,
      this.lastEndDateSelected)
  }

  handleEndDateChanged = (n, date) => {
    const newEndDate = moment(date).format('YYYY-MM-DD')
    FunctionUtils.changeDateModuleWithDates(
      this.props.teamId,
      this.props.jobInfo,
      this.getModuleInfo().startDate,
      newEndDate)
  }

  render() {
    // Show End Date if it is not recurrent or it is editing a recurrent job
    // with end date selected
    const showEndDateView = !this.getRecurrence() || (!this.props.jobInfo.temporal
      && this.getModuleInfo().endDate !== '2018-12-31'
      && this.getModuleInfo().endDate !== '2019-06-30'
      && this.getModuleInfo().endDate !== '2019-12-31')
    return (
      <div
        style={styles.container}>
        <DateInput
          value={this.getDate()}
          disabled={!this.props.jobInfo.temporal && this.getRecurrence() !== undefined}
          shouldDisableDate={() => false}
          hintText='Start date'
          onChange={this.handleStartDateChanged} />
        { showEndDateView && 
          <div
            style={styles.separator}>
            {this.getRecurrence() ? 'Last day:' : 'to'}
          </div>
        }
        { showEndDateView &&
          <DateInput
            value={moment(this.getModuleInfo().endDate).toDate()}
            disabled={!this.props.jobInfo.temporal && this.getRecurrence() !== undefined}
            shouldDisableDate={this.shouldDisableDate}
            hintText='End date'
            onChange={this.handleEndDateChanged} />
        }
      </div>
    )
  }

}

const styles = {
  
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wap'    
  },

  separator: {
    marginLeft: 8,
    marginRight: 8,
    color: '#757575'
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/date/DateView.js